module.exports = __webpack_public_path__ + "img/personaje.3891b79c.png";